import { Form, Select } from 'antd';
import React from 'react';

import { DAY_OPTIONS, WEEK_DAY_OPTIONS } from './constants';

type CycleDaysFieldProps = {
  cycleType: string;
};

const CycleDaysField = ({ cycleType }: CycleDaysFieldProps) => {
  return cycleType === 'month' ? (
    <Form.Item
      label="日期"
      name={['cycle', 'days']}
      rules={[{ required: true, message: '請選擇日期', type: 'array' }]}
    >
      <Select
        showArrow
        allowClear
        mode="multiple"
        placeholder="請選擇日期"
        options={DAY_OPTIONS}
      />
    </Form.Item>
  ) : (
    <Form.Item
      label="星期"
      name={['cycle', 'days']}
      rules={[{ required: true, message: '請選擇星期', type: 'array' }]}
    >
      <Select
        showArrow
        allowClear
        mode="multiple"
        placeholder="請選擇星期"
        options={WEEK_DAY_OPTIONS}
      />
    </Form.Item>
  );
};

export default CycleDaysField;
